import { createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 tw-text-left" }
const _hoisted_2 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-slate-700 sm:tw-col-span-2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["maxlength"]
const _hoisted_6 = { class: "tw-mt-1 tw-flex tw-items-center tw-gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "tw-text-xs tw-text-slate-500"
}
const _hoisted_8 = {
  key: 1,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_9 = { class: "tw-mt-1 tw-flex tw-items-center tw-gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_11 = { class: "tw-mt-6 tw-flex tw-items-center tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:isOpen', $event))),
    modalId: `edit-reefer-details-${_ctx.container?.id}`,
    subtitle: "Genset, temperature and vents settings for this reefer, then save.",
    maxWidth: "2xl"
  }, {
    title: _withCtx(() => [...(_cache[7] || (_cache[7] = [
      _createTextVNode("Edit reefer details", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingReeferDetails.isGensetRequired) = $event)),
            type: "checkbox",
            class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300",
            disabled: _ctx.isSaving
          }, null, 8, _hoisted_3), [
            [_vModelCheckbox, _ctx.editingReeferDetails.isGensetRequired]
          ]),
          _cache[8] || (_cache[8] = _createTextVNode(" Genset needed ", -1))
        ]),
        (_ctx.editingReeferDetails.isGensetRequired)
          ? (_openBlock(), _createBlock(_component_FilterableDropdown, {
              key: 0,
              modelValue: _ctx.editingReeferDetails.gensetApprovalChoice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingReeferDetails.gensetApprovalChoice) = $event)),
              textLabel: "Genset approved by shipline",
              options: _ctx.gensetApprovalOptions,
              label: "label",
              reduce: (option) => option.value,
              clearable: false,
              components: { Deselect: null }
            }, null, 8, ["modelValue", "options", "reduce"]))
          : _createCommentVNode("", true),
        (_ctx.editingReeferDetails.isGensetRequired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Genset number", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingReeferDetails.gensetNumber) = $event)),
                type: "text",
                maxlength: _ctx.maxGensetNumberLength,
                placeholder: "Not specified",
                class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-uppercase tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-normal-case placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
              }, null, 8, _hoisted_5), [
                [_vModelText, _ctx.editingReeferDetails.gensetNumber]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Temperature", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingReeferDetails.gensetTemperatureValue) = $event)),
              type: "number",
              step: "1",
              class: _normalizeClass(["tw-w-28 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40", { 'tw-border-rose-400': !_ctx.getIsTemperatureInRange() }])
            }, null, 2), [
              [_vModelText, _ctx.editingReeferDetails.gensetTemperatureValue]
            ]),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['F', 'C'], (unit) => {
              return _createVNode(_component_Button, {
                onClick: ($event: any) => (_ctx.editingReeferDetails.gensetTemperatureUnit = unit),
                isPrimary: _ctx.editingReeferDetails.gensetTemperatureUnit === unit,
                isSecondary: _ctx.editingReeferDetails.gensetTemperatureUnit !== unit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(unit), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "isPrimary", "isSecondary"])
            }), 64))
          ]),
          (_ctx.convertedTemperatureHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.convertedTemperatureHint), 1))
            : _createCommentVNode("", true),
          (!_ctx.getIsTemperatureInRange())
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Must be between -70°C and 30°C (-94°F and 86°F). "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Vents open", -1)),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingReeferDetails.gensetVentsOpenPercent) = $event)),
              type: "number",
              min: "0",
              max: "100",
              step: "5",
              placeholder: "Not specified",
              class: _normalizeClass(["tw-w-32 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40", { 'tw-border-rose-400': !_ctx.getIsVentsOpenPercentInRange() }])
            }, null, 2), [
              [_vModelText, _ctx.editingReeferDetails.gensetVentsOpenPercent]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "tw-text-sm tw-text-slate-500" }, "%", -1))
          ]),
          (!_ctx.getIsVentsOpenPercentInRange())
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Must be a whole number between 0 (closed) and 100 (open). "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          isGreen: true,
          enableLoading: _ctx.isSaving,
          disabled: _ctx.isSaving || !_ctx.getIsTemperatureInRange() || !_ctx.getIsVentsOpenPercentInRange(),
          isPrimary: true,
          onClick: _ctx.saveReeferDetails,
          icon: "check",
          title: "Save reefer details",
          "aria-label": "Save reefer details"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["enableLoading", "disabled", "onClick"]),
        _createVNode(_component_Button, {
          isRed: true,
          isSecondary: true,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:isOpen', false))),
          title: "Cancel edit reefer details",
          "aria-label": "Cancel edit reefer details"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "modalId"]))
}